import { Box, styled } from "@mui/material";
export const GridAutoColumn2 = styled(Box)(({ theme }) => ({
    display: "grid",
    gridTemplateColumns: "repeat(2, minmax(350px, 1fr))",
    gap: "1rem",
    gridTemplateRows: "auto",
    padding: "1rem 3rem",
    [theme.breakpoints.down("sm")]: {
        gridTemplateColumns: "repeat(1, minmax(350px, 1fr))",
    },
    [theme.breakpoints.between("sm", "md")]: {
        gridTemplateColumns: "repeat(2, minmax(350px, 1fr))",
    },
}));


export const GridAutoColumnForm2= styled("div")(({theme})=>({
    display:"grid",
    gridTemplateColumns: "repeat(2, minmax(0, 1fr))",
    columnGap:"1rem",
    [theme.breakpoints.down('md')]:{
        gridTemplateColumns: "repeat(1, minmax(0, 1fr))",
        rowGap:"1rem",
    }
}))

export const GridAutoColumnChart= styled("div")(({theme})=>({
    display:"grid",
    gridTemplateColumns: "repeat(3, minmax(1, 1fr))",
    padding:"2rem",
    columnGap:"1rem",
    rowGap:"5rem",
   
    [theme.breakpoints.up('sm')]:{
        gridTemplateColumns: "repeat(2, minmax(0, 1fr))",
        rowGap:"1rem",
    },
    [theme.breakpoints.up('md')]:{
        gridTemplateColumns: "repeat(2, minmax(0, 1fr))",
        rowGap:"1rem",
    },
    [theme.breakpoints.up('lg')]:{
        gridTemplateColumns: "repeat(2, minmax(0, 1fr))",
        rowGap:"1rem",
    },
    [theme.breakpoints.up('xl')]:{
        gridTemplateColumns: "repeat(2, minmax(0, 1fr))",
        rowGap:"1rem",
    },
    border: "1px solid #ccc",
    borderRadius: "8px",
    boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)",
}))

export const GridforCards = styled("div")(({theme})=>({
    display:"grid",
    gridTemplateColumns: "repeat(2, minmax(0, 1fr))",
    gap:"0.5rem",
    padding:"0.5rem",
    rowGap:"1rem",
    [theme.breakpoints.up('md')]:{
        gridTemplateColumns: "repeat(3, minmax(0, 1fr))",
    },
    [theme.breakpoints.up('lg')]:{
        gridTemplateColumns: "repeat(5, minmax(0, 1fr))",
    },
    [theme.breakpoints.up('xl')]:{
        gridTemplateColumns: "repeat(5, minmax(0, 1fr))",
    },
}));
